import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=47d11c20&scoped=true&"
import script from "./PaymentForm.vue?vue&type=script&lang=ts&"
export * from "./PaymentForm.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=47d11c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d11c20",
  null
  
)

export default component.exports